import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-districtform',
  templateUrl: './districtform.component.html',
  styleUrls: ['./districtform.component.css']
})
export class DistrictformComponent implements OnInit {
title =  'District Details';
  mode: any;
  DI_Id: number;
  StateData: any;
  State: any = [];
  data: any;
  D: any = {};

constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }


  ngOnInit() {
    this.GetStateDropDown();
    this.route.params.subscribe(params => {
      this.DI_Id = params['DI_Id'];
      this.mode = params['mode'];

      if (this.DI_Id > 0) {

        this.GetByIdDistrict(this.DI_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View District ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit District ";
    }
  }

  GetStateDropDown() {
    this.StateData = this.userService.GetStateDropDown();
    this.StateData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.State = Resp.Result;
      }
    )
  }

  CreateDistrict(District: NgForm) {
    debugger;
    this.data = this.userService.CreateDistrict(District.value);
    this.data.subscribe(
      (response) => {
        District.reset();
        District.resetForm();
        District.form.markAsPristine();
        District.form.markAsUntouched();
        swal('Success!', 'District Details Added Successfully .', 'success');
        this.router.navigate(['/home/district']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  GetByIdDistrict(DI_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdDistrict(DI_Id);
    this.data.subscribe(
      (response: any) => {
        this.D = response;
      }, (error) => {
      });
  }

  UpdateDistrict(Doctor: NgForm) {
    debugger;
    this.data = this.userService.UpdateDistrict(this.DI_Id,Doctor.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' District details updated Successfully .', 'success');
        this.router.navigate(['/home/district']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/district/districtform/districtform.component.ts